/* eslint-disable prefer-destructuring,func-names,react/prop-types */
/* eslint-disable react/prefer-stateless-function,react/destructuring-assignment */

import React, { Component } from 'react';
import _ from 'lodash';
import { Switch, Route } from 'react-router-dom';
import Home from '../Home';
import Callback from '../Callback';
import MediaBrowser from '../MediaBrowser';
import Terminus from '../Terminus';
import TerminusDrilldown from '../TerminusDrilldown';
import KeyManager from '../KeyManager';
import SpottingGroups from '../SpottingGroup';
import SpottingGroupDrilldown from '../SpottingGroupDrilldown';
import { LOADED } from '../../store/sharedConstants';
import Jobs from '../Jobs';
import Category from './../Category';
import CategoryDrilldown from '../CategoryDrilldown';
import Query from '../Query';

const ROUTE_MAP = new Map();

ROUTE_MAP.set('home', Home);
ROUTE_MAP.set('query', Query);
ROUTE_MAP.set('callback', Callback);
ROUTE_MAP.set('media-browser', MediaBrowser);
ROUTE_MAP.set('vocabulary-lists', Terminus);
ROUTE_MAP.set('vocabulary-lists-drilldown', TerminusDrilldown);
ROUTE_MAP.set('vocabulary-lists-new', ({ props }) => <TerminusDrilldown {...props} newList />);
ROUTE_MAP.set('bearer-token', KeyManager);
ROUTE_MAP.set('spotting-groups', SpottingGroups);
ROUTE_MAP.set('spotting-groups-drilldown', SpottingGroupDrilldown);
ROUTE_MAP.set('spotting-groups-new', ({ props }) => <SpottingGroupDrilldown {...props} newList />);
ROUTE_MAP.set('categorization-jobs', Jobs);
ROUTE_MAP.set('categories', Category);
ROUTE_MAP.set('categories-drilldown', CategoryDrilldown);
ROUTE_MAP.set('categories-new', ({ props }) => <CategoryDrilldown {...props} newCat />);

// <Route path="/jobs" exact component={Jobs} />
export default (bottle) => {
  bottle.factory('MainRoutes', () => ({ pages }) => {
    const routes = pages ? _(pages)
      .filter('route')
      .map(page => ({
        key: page.key,
        path: page.route,
        exact: page.exact,
        component: ROUTE_MAP.get(page.key),
      })).value() : [];
    return <Switch>{routes.map(props => <Route {...props} />)}</Switch>;
  });

  bottle.factory('MainContainer', ({ MainView, MainRoutes, LoadingScreen }) => class MainContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        sidebarCollapsed: window && window.width < 1090,
      };
      this.onOpenWindow = this.onOpenWindow.bind(this);
      this.toggleSidebar = this.toggleSidebar.bind(this);
      this.collapseSidebar = this.collapseSidebar.bind(this);
    }
    // this is a "Development hack" to fix the fact that the neutrino router doesn't
    // always redirect to deep links properly.
    componentDidMount() {
      this.props.startGatekeeper();
      const s = window.location.search;
      if (s) {
        const q = /route=(.*)/.exec(s);
        if (q && q[1]) {
          this.props.history.push(q[1]);
        }
      }
      window.addEventListener("resize", () => {
        const { sidebarCollapsed } = this.state;
        if (window && (window.innerWidth < 1090) && !sidebarCollapsed) this.collapseSidebar();
      });
    }

    onOpenWindow(url) {
      window.open(url, '_blank');
    }

    go(page) {
      if (!page) return;
      if (page.link) {
        this.onOpenWindow(page.link);
      } else {
        this.props.history.push(page.route);
      }
      if (_.get(page, 'fullWidth')) this.collapseSidebar();
    }

    collapseSidebar() {
      this.setState({ sidebarCollapsed: true });
    }

    toggleSidebar() {
      const { sidebarCollapsed } = this.state;
      this.setState({ sidebarCollapsed: !sidebarCollapsed });
    }

    render() {
      const { sidebarCollapsed } = this.state;
      const { history, location, tokenStatus, userPages } = this.props;
      const currentPage = _.find(userPages, x => x.route === location.pathname) || {};
      return (
        <MainView
          go={key => this.go(key)}
          history={history}
          location={location}
          menuSelection={location.pathname.split('/')[1]}
          onOpenWindow={this.onOpenWindow}
          isLoaded={(tokenStatus === LOADED)}
          pages={_.filter(userPages, 'onMenu')}
          toggleSidebar={this.toggleSidebar}
          collapseSidebar={this.collapseSidebar}
          sidebarCollapsed={sidebarCollapsed}
          fullWidth={currentPage && currentPage.fullWidth}
        >
          {(tokenStatus === LOADED) && <MainRoutes pages={userPages} />}
          {(tokenStatus !== LOADED) && <LoadingScreen {...this.props} />}
        </MainView>
      );
    }
  });
};
